<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <!-- <feather-icon
      class="hidden"
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    /> -->
  </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router
        .push(`/associate/users/vendor/edit/${this.params.data ? this.params.data.id : 0}`)
        .catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data ? this.params.data.name : ''}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /*this.showDeleteSuccess()*/
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch('userManagement/deleteUser', this.params.data.id)
        .then(()   => {
          this.showDeleteSuccess()
          this.params.api.purgeInfiniteCache()
        })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The user was successfully deleted'
      })
    }
  }
}
</script>
